import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-type',
  templateUrl: './content-type.component.html',
})
export class ContentTypeComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
